import type { SettingSectionLayout } from '../settingLayout';

/** The "Timecards and expenses" section: its group bands and their rows, in page order. */
export const TIMECARDS_SECTION: SettingSectionLayout = { anchor: 'timecards', groups: [] };
